import ILoggingListener from "./ILoggingListener";

export default class ConsoleLogger implements ILoggingListener {

    private readonly logFunction: (msg: string)=>void = null;

    constructor(logFunction: (msg: string)=>void = null) {
        this.logFunction = logFunction;
    }

    public logMessage(message: string) {
        if(this.logFunction === null) {
            console.log(message)
        } else {
            this.logFunction(message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/logging/ConsoleLogger.ts